$(function () {
    /**
     * Cart sidebar
     */
    $("body").on('click', '.btn-cart-sidebar', function (e) {
        e.preventDefault();
        showMiniCart();
    });

    $("body").on('click', '*[data-action="close-minicart"]', function (e) {
        e.preventDefault();
        closeMiniCart();
    });

    function showMiniCart(){
        $('body').toggleClass('show-cart-sidebar');
    }

    function closeMiniCart(){
        $('body').removeClass('show-cart-sidebar');
    }

    /**
     * Search popup
     */
    $("body").on('click', '.btn-search-popup', function (e) {
        e.preventDefault();
        showSearch();
    });

    $("body").on('click', '*[data-action="close-search"]', function (e) {
        e.preventDefault();
        closeSearch();
    });

    function showSearch(){
        $('body').toggleClass('show-search');
    }

    function closeSearch(){
        $('body').removeClass('show-search');
    }
    /* related posts slider */

  $(function () {
    $('.related-articles .owl-carousel').owlCarousel({
      checkVisibility: false,
      loop: 0,
      autoplay: 0,
      margin: 30,
      nav: 1,
      dots: 0,
      responsive: {
        0: { items: 1 },
        481: { items: 2 },
        768: { items: 2 },
        992: { items: 3 },
        1200: { items: 3 },
        1441: { items: 3 },
        1681: { items: 3 },
        1921: { items: 3 }
      }
    });
  });

  $(function () {
    $('.partner-brand .owl-carousel').owlCarousel({
      checkVisibility: false,
      loop: 0,
      autoplay: 0,
      margin: 30,
      nav: 1,
      dots: 0,
      responsive: {
        0: { items: 1 },
        481: { items: 2 },
        768: { items: 2 },
        992: { items: 3 },
        1200: { items: 3 },
        1441: { items: 3 },
        1681: { items: 3 },
        1921: { items: 3 }
      }
    });
  });

/* Mobile header */
function isEmpty( el ){
    return !$.trim(el.html())
}

function mobile_header(){
    if ($(window).width() <= 1024) {
        if (isEmpty($('#cart-mobile'))) { $('.header-desktop .header-cart.minicart-header').not('.header-cart-block').first().clone().appendTo('#cart-mobile'); }
        if (isEmpty($('#search-mobile'))) { $('.header-desktop .search-header').clone().appendTo('#search-mobile'); }
        if (isEmpty($('#menu-mobile'))) { $('.header-desktop .header-megamenu .megamenu-horizontal .horizontal-content').clone().appendTo('#menu-mobile'); }
    }
}
mobile_header();
var windowWidth = $(window).width();
$(window).on('resize', function(){
    if(windowWidth != $(window).width()) {
        mobile_header();
    }
});

$("body").on('click', '#mobile-nav,.nav-mobile-overlay,.close-mobile', function () {
    $('body').toggleClass('show-nav-mobile');
});

$("#menu-mobile .menu-items >.item .btn-drop-mobile").on('click', function () {
    $(this).closest('.item').toggleClass('show-dropdown-menu');
});

if ($(window).width() <= 767) {
    $('.tab-container .list-tabs .tab-item.active .tab-title').clone().appendTo('.tabs-drop-mobile');
    $('.tabs-drop-mobile').on('click', function(){
        $(this).closest('.tab-container').toggleClass('active');
    });
    $('.tab-container .list-tabs .tab-item').on('click', function(){
        var tit = $(this).find('.tab-title').clone();
        $('.tabs-drop-mobile').html(tit);
        $(this).closest('.tab-container').removeClass('active');
    });
}
/* Predictive Search */
var searchTimer;
$(document).on('input', '.search-header__input', function() {
    var query = $(this).val().trim();
    var $suggestions = $(this).siblings('#search-suggestions');

    clearTimeout(searchTimer);

    if (query.length < 2) {
        $suggestions.hide().empty();
        return;
    }

    searchTimer = setTimeout(function() {
        $.getJSON('/search/suggest.json', {
            q: query,
            resources: {
                type: 'product,collection',
                limit: 5
            },
            'resources[type]': 'product,collection',
            'resources[limit]': 5
        }, function(data) {
            var html = '';
            var products = data.resources.results.products || [];
            var collections = data.resources.results.collections || [];

            if (products.length > 0) {
                html += '<div style="padding:8px 12px; font-size:11px; color:#999; text-transform:uppercase; font-weight:600;">Productos</div>';
                products.forEach(function(p) {
                    html += '<a href="' + p.url + '" style="display:flex; align-items:center; padding:8px 12px; text-decoration:none; color:#333; border-top:1px solid #f0f0f0;">';
                    if (p.featured_image && p.featured_image.url) {
                        html += '<img src="' + p.featured_image.url + '" style="width:40px; height:40px; object-fit:contain; margin-right:10px; border-radius:3px;">';
                    }
                    html += '<span>' + p.title + '</span></a>';
                });
            }

            if (collections.length > 0) {
                html += '<div style="padding:8px 12px; font-size:11px; color:#999; text-transform:uppercase; font-weight:600; border-top:1px solid #e0e0e0;">Colecciones</div>';
                collections.forEach(function(c) {
                    html += '<a href="' + c.url + '" style="display:block; padding:8px 12px; text-decoration:none; color:#333; border-top:1px solid #f0f0f0;">' + c.title + '</a>';
                });
            }

            if (html === '') {
                html = '<div style="padding:12px; color:#999;">Sin resultados</div>';
            }

            $suggestions.html(html).show();
        });
    }, 300);
});

$(document).on('click', function(e) {
    if (!$(e.target).closest('.search-header').length) {
        $('#search-suggestions').hide();
    }
});

});